import React from "react";
import SecadoList from "../../../components/user/standAloneProcess/secadoResume";
import Layout from "../../../components/layouts/verticalLayout";

const SecadoListPage = (props) => {
  return <Layout body={<SecadoList />} />;
};

SecadoListPage.propTypes = {};

export default SecadoListPage;
